/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Why_Point3Inputs */

const en_dr_why_point3 = /** @type {(inputs: Dr_Why_Point3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online whiteboards stall at convergence: too much information, no facilitator role (Lim et al. 2023) — Design Room fixes this with a navigator and a hard card limit per step.`)
};

const id_dr_why_point3 = /** @type {(inputs: Dr_Why_Point3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whiteboard online mandek di tahap konvergensi: informasi berlebih, peran fasilitator kosong (Lim dkk. 2023) — Design Room memperbaikinya dengan navigator langkah dan batas jumlah kartu per langkah.`)
};

/**
* | output |
* | --- |
* | "Online whiteboards stall at convergence: too much information, no facilitator role (Lim et al. 2023) — Design Room fixes this with a navigator and a hard car..." |
*
* @param {Dr_Why_Point3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_why_point3 = /** @type {((inputs?: Dr_Why_Point3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Why_Point3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_why_point3(inputs)
	return en_dr_why_point3(inputs)
});